import { IconPropTypes } from '@/legacy/types';

const FrekuentLogoFull = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={104}
			height={22}
			fill='none'
			{...props}
		>
			<path
				fill='#27225C'
				d='M8.036 0c2.082 0 4.308.996 4.741 3.047L9.915 4.13c-.23-.996-.867-1.524-1.879-1.524-1.185 0-2.052.909-2.052 2.637v1.494h3.903v2.578H5.984V20.83H2.66V9.316H0V6.738h2.66V5.391C2.66 2.05 4.799 0 8.036 0Z'
			/>
			<path
				fill='#27225C'
				d='M10.916 6.738h3.325v2.783c.607-1.933 2.226-3.193 4.191-3.193a3.9 3.9 0 0 1 1.85.44l-.317 3.193c-.665-.381-1.301-.586-2.082-.586-1.387 0-3.642.908-3.642 4.658v6.796h-3.325V6.74ZM26.817 8.847c-1.995 0-3.295 1.407-3.556 3.34h6.765c.058-1.845-.954-3.34-3.209-3.34ZM19.88 13.77c0-4.043 2.717-7.441 6.996-7.441 4.77 0 7.198 3.896 6.36 7.94H23.088c.029 3.046 1.85 4.364 3.758 4.364 1.995 0 3.006-1.025 3.18-2.49l3.267.235c-.347 2.695-2.631 4.833-6.418 4.833-4.394.03-6.996-3.31-6.996-7.44ZM35.089.381h3.324v11.982l5.753-5.625h4.308l-5.522 5.186 5.753 8.906H44.86l-4.22-6.738-2.227 2.08v4.658H35.09V.38ZM55.421 18.456c2.11 0 3.671-1.67 3.671-4.775V6.738h3.325v14.091h-3.325v-2.46c-.838 1.64-2.544 2.87-4.74 2.87-3.18 0-5.175-2.109-5.175-5.83V6.739H52.5v8.174c0 2.255 1.157 3.544 2.92 3.544ZM70.863 8.847c-1.995 0-3.296 1.407-3.556 3.34h6.765c.058-1.845-.954-3.34-3.21-3.34Zm-6.938 4.922c0-4.043 2.717-7.441 6.996-7.441 4.77 0 7.198 3.896 6.36 7.94H67.133c.029 3.046 1.85 4.364 3.758 4.364 1.995 0 3.006-1.025 3.18-2.49l3.266.235c-.346 2.695-2.63 4.833-6.417 4.833-4.394.03-6.996-3.31-6.996-7.44ZM86.17 9.111c-2.11 0-3.67 1.67-3.67 4.775v6.944h-3.325V6.737h3.324V9.2c.839-1.64 2.544-2.871 4.741-2.871 3.18 0 5.175 2.11 5.175 5.83v8.671H89.09v-8.173c0-2.256-1.156-3.545-2.92-3.545ZM102.854 6.738v2.578h-4.028v6.797c0 1.64.694 2.343 1.821 2.343.636 0 1.388-.263 1.908-.908l.55 2.725c-.665.585-1.879.937-2.891.937-2.92 0-4.712-1.728-4.712-4.658V9.316h-2.56V6.738h9.912Z'
			/>
			<path
				fill='#9B86EC'
				fillRule='evenodd'
				d='M102.854.06v3.05s-2.024 1.566-4.956 2.326c-2.635.68-4.956.68-4.956.68V3.554s2.4-.036 4.956-.929c3.578-1.238 4.956-2.564 4.956-2.564Z'
				clipRule='evenodd'
			/>
		</svg>
	);
};

export default FrekuentLogoFull;
